import React from 'react';
import CollapsiblePanel from '../CollapsiblePanel';

const ReferencePanel = (props) => {
  return (
    <div className="reference-panel">
      <CollapsiblePanel
        Id="referencepanel"
        className="c-collapsible-panel"
        DefaultCollapsed={props.collapsed}
        Heading={props.referenceList.panelHeading}
      >
        {props.referenceList?.texts.map((item, key) => (
          <p
            key={key}
            dangerouslySetInnerHTML={{
              __html: item,
            }}
          ></p>
        ))}
      </CollapsiblePanel>
    </div>
  );
};

export default ReferencePanel;
